import { v4 as uuidv4 } from 'uuid';
import { IComponentProps } from '.';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';

export const generate = (
  props?: Partial<IComponentSchema<IComponentProps>>
): IComponentSchema<IComponentProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Divider',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.Divider,
    'x-component-props': {
      type: 'horizontal',
      orientation: 'center',
      variant: 'solid',
      plain: true,
      visible: true,
    },
    'x-component-props-config': {},
  };
};
